import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { AfRoutes } from '../../routes';
import { AuthorizationService } from './authorization.service';
import { Roles } from './roles';

export function cpAdminGuard(): CanMatchFn {
  return (): boolean | UrlTree => {
    const authorizationService = inject(AuthorizationService);
    const router = inject(Router);

    return authorizationService.isCPAdmin() || router.createUrlTree([AfRoutes.welcomePage]);
  };
}
